import { Avatar, Box, Typography } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';

type Props = {
  name: string;
  subtitle?: string;
  size?: 'small' | 'medium' | 'large';
  showName?: boolean;
  showDropdownArrow?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  isClickable?: boolean;
};

const UserAvatar = ({
  name,
  subtitle,
  size = 'medium',
  showName = true,
  showDropdownArrow = false,
  onClick,
  isClickable = false
}: Props) => {
  const getInitials = (fullName: string) => {
    const names = fullName.trim().split(' ');
    const initials = names
      .map(n => n[0])
      .join('')
      .toUpperCase();
    return initials.slice(0, 2);
  };

  const sizeMap = {
    small: 32,
    medium: 40,
    large: 48
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        cursor: isClickable ? 'pointer' : 'default',
        padding: isClickable ? '6px 8px' : 0,
        borderRadius: 1,
        transition: 'all 0.2s ease-in-out',
        '&:hover': isClickable
          ? {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              transform: 'translateY(-1px)'
            }
          : {}
      }}
      onClick={onClick}
    >
      {showName && (
        <Box sx={{ textAlign: 'right' }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.2 }}>
            {name}
          </Typography>
          {subtitle && (
            <Typography
              variant="caption"
              sx={{ color: 'text.secondary', lineHeight: 1.2 }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
      <Avatar
        sx={{
          width: sizeMap[size],
          height: sizeMap[size],
          bgcolor: 'primary.light',
          color: 'primary.dark',
          fontSize: size === 'small' ? '0.875rem' : '1rem',
          fontWeight: 500
        }}
      >
        {getInitials(name)}
      </Avatar>
      {showDropdownArrow && (
        <KeyboardArrowDown
          sx={{
            fontSize: '1.2rem',
            color: 'text.secondary',
            transition: 'transform 0.2s ease-in-out'
          }}
        />
      )}
    </Box>
  );
};

export default UserAvatar;
